// Layout-import endpoints (B.2). Two-phase: preview a CSV to get a diff
// + parse_token, then commit the SAME File with that token.

import { request, type ApiResponse } from "../client";
import { buildMultipart } from "../multipart";
import type { CommitResponse, PreviewResponse } from "../types/layoutImport";

function base(a: string, t: string, s: string): string {
  return `/api/v1/accounts/${encodeURIComponent(a)}/tenants/${encodeURIComponent(
    t,
  )}/sites/${encodeURIComponent(s)}/layout-import`;
}

export const layoutImport = {
  preview: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    file: File,
  ): Promise<ApiResponse<PreviewResponse>> =>
    request<PreviewResponse>(
      "POST",
      `${base(accountSlug, tenantSlug, siteSlug)}/preview`,
      buildMultipart(file),
    ),

  commit: (
    accountSlug: string,
    tenantSlug: string,
    siteSlug: string,
    file: File,
    parseToken: string,
    applyUpdates = false,
  ): Promise<ApiResponse<CommitResponse>> =>
    request<CommitResponse>(
      "POST",
      `${base(accountSlug, tenantSlug, siteSlug)}/commit`,
      buildMultipart(file, {
        parse_token: parseToken,
        apply_updates: String(applyUpdates),
      }),
    ),
};
